<script>
import { addSubscriberList, updateSubscriberList } from "@/api/subscribers";
export default {
  name: "add-subscribers-list-modal",
  data() {
    return {
      form: {
        name: ""
      },
      item: null,
      title: "Add Subscriber List",
      spinning: false
    };
  },
  computed: {
    getItem() {
      return this.$store.getters["getSubscribersListItem"];
    }
  },
  watch: {
    getItem(newVal) {
      this.item = newVal;
      this.form.name = newVal ? newVal.name : "";
      this.title = newVal ? "Update Subscriber List" : "Add Subscriber List";
    }
  },
  methods: {
    hide() {
      this.spinning = false;
      this.form.name = "";
      this.$store.dispatch("getSubscribersList");
      this.$refs["add-subscriber-list-modal"].hide();
    },
    async onSubmit() {
      const payload = JSON.parse(JSON.stringify(this.form));
      // this.$store.commit("setFormData", payload);
      this.spinning = true;
      if (this.item) {
        // this.$store.dispatch("updateSubscriberList", payload);
        let response = await updateSubscriberList(this.item.id, payload);
        if (response.id) {
          this.$bvToast.toast(`Updated`, {
            title: "Subscriber List",
            autoHideDelay: 3000,
            appendToast: false,
            variant: "info"
          });
        }
      } else {
        // this.$store.dispatch("addSubscriberList", payload);
        let response = await addSubscriberList(payload);
        if (response.id) {
          this.$bvToast.toast(`Added`, {
            title: "Subscriber List",
            autoHideDelay: 3000,
            appendToast: false,
            variant: "info"
          });
        }
      }
      setTimeout(() => {
        this.spinning = false;
        this.form.name = "";
        this.$store.dispatch("getSubscribersList");
        this.$refs["add-subscriber-list-modal"].hide();
      }, 2000);
    }
  }
};
</script>

<template>
  <b-modal
    id="add-subscriber-list-modal"
    ref="add-subscriber-list-modal"
    :title="title"
    size="sm"
    no-close-on-esc
    no-close-on-backdrop
    centered
    hide-footer
  >
    <b-form
      v-on:submit.prevent="onSubmit"
      method="POST"
      id="add-subscriber-list-form"
    >
      <b-form-group
        id="input-group-1"
        label="Name:"
        label-for="input-1"
        description="Subcribers list name."
      >
        <b-form-input
          id="input-1"
          v-model="form.name"
          type="text"
          required
          placeholder="Enter name"
        ></b-form-input>
      </b-form-group>

      <b-button
        type="submit"
        class="float-right"
        variant="primary"
        v-if="!spinning"
      >
        Submit Changes
      </b-button>
      <b-spinner
        v-show="spinning"
        label="Spinning"
        class="float-right"
      ></b-spinner>
    </b-form>
  </b-modal>
</template>
